export default "__VITE_ASSET__81628139__"